import { format } from "date-fns";

export const formatMasterDate = (value) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return format(date, "dd MMM yyyy, hh:mm a");
};

export const isActiveStatus = (value) =>
  value === 1 || value === true || value === "1";

export const getStatusLabel = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return isActiveStatus(value) ? "Active" : "Inactive";
};

export const getStatusFormValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  return isActiveStatus(value) ? "1" : "0";
};

const flattenApiErrors = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => flattenApiErrors(item))
      .filter(Boolean)
      .join(", ");
  }

  if (value && typeof value === "object") {
    return Object.values(value)
      .map((item) => flattenApiErrors(item))
      .filter(Boolean)
      .join(", ");
  }

  if (value === null || value === undefined) {
    return "";
  }

  return String(value).trim();
};

export const extractApiErrorMessage = (
  error,
  fallback = "Something went wrong. Please try again."
) => {
  const responseData = error?.response?.data;

  return (
    flattenApiErrors(responseData?.message) ||
    flattenApiErrors(responseData?.error) ||
    flattenApiErrors(responseData?.errors) ||
    error?.message ||
    fallback
  );
};

const normalizeText = (value) => String(value ?? "").toLowerCase().trim();

export const matchesSearch = (values, searchTerm) => {
  const normalizedSearch = normalizeText(searchTerm);

  if (!normalizedSearch) {
    return true;
  }

  return values.some((value) => normalizeText(value).includes(normalizedSearch));
};

export const buildLookupMap = (items, labelKey = "name") =>
  items.reduce((accumulator, item) => {
    if (item?.id) {
      accumulator[item.id] = item[labelKey] || "-";
    }

    return accumulator;
  }, {});

export const toSelectOptions = (items, labelKey = "name") =>
  items.map((item) => ({
    label: item?.[labelKey] || "-",
    value: item?.id || "",
  }));

export const getDefaultUserState = () => localStorage.getItem("userState") || "";

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

export const preferredLanguageOptions = [
  { label: "English", value: "English" },
  { label: "Gujarati", value: "Gujarati" },
  { label: "Hindi", value: "Hindi" },
  { label: "Marathi", value: "Marathi" },
];

export const roleOptions = [
  { label: "Super Admin", value: "super_admin" },
  { label: "Admin", value: "admin" },
  { label: "Officer", value: "officer" },
  { label: "Station User", value: "station_user" },
];

export const statusOptions = [
  { label: "Active", value: "1" },
  { label: "Inactive", value: "0" },
];
